module.exports = __webpack_public_path__ + "img/ressource-02.c9c5e3ba.svg";